export const config =  {
    apiUrl: process.env.VUE_APP_API_URL,
    alertFrequency: 30000
}